export default "__VITE_ASSET__qZmb316N__"